import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

// A router wrapper, adding extra functions.
@Injectable({ providedIn: 'root' })
export class RouterExtensionService {

  private previousUrl: string = undefined;
  private currentUrl: string = undefined;
  private isBackButtonClicked = false;
  private componentBackUrls: Map<string, string[]>;

  constructor(private router: Router) {
    this.componentBackUrls = new Map<string, string[]>();
    this.currentUrl = this.router.url;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      }
    });
  }

  getPreviousUrl(): string {
    return this.previousUrl;
  }

  getIsBackButtonClicked(): boolean {
    return this.isBackButtonClicked;
  }

  setIsBackButtonClicked(value: boolean): void {
    this.isBackButtonClicked = value;
  }

  getComponentBackUrl(componentName: string): string {
    const backUrls = this.getComponentBackUrls(componentName);
    let backurl = '';
    if (backUrls.length > 0) {
      backurl = backUrls[backUrls.length - 1];
    }
    return backurl;
  }

  pushComponentBackUrl(componentName: string, url: string): void {
    this.getComponentBackUrls(componentName).push(url);
  }

  popComponentBackUrl(componentName: string): void {
    this.getComponentBackUrls(componentName).pop();
  }

  private getComponentBackUrls(componentName: string): string[] {
    if (!this.componentBackUrls.has(componentName)) {
      this.componentBackUrls.set(componentName, []);
    }
    return this.componentBackUrls.get(componentName);
  }
}
